export const environment = {
  apiUrl: 'https://api.nsinstallazioni.it/v1',
  appUrl: 'https://app.nsinstallazioni.it',
  nodeUrl: 'https://node.nsinstallazioni.it',
  projectId: '697d1c420027f6b914f8',
  databaseId: '6929ad46001d10f171db',
  eventsCollectionId: '6929ad7d0012f1943f5a',
  documentsBucketId: '6937ed8b002f22b2bf6d',
};
